import axios from 'axios';
import settings from '../settings.js';

export function getTable(table) {
  return axios.get(`${settings.API_URL}${table}`);
}

export const helpers = {
  getTables: (table1, table2) => {
    return axios
      .all([getTable(table1), getTable(table2)])
      .then(function(arr) {
        return {
          countryData: arr[0].data.records,
          subjectData: arr[1].data.records
        };
      })
      .catch(error => {
        console.log(error);
      });
  }
};
// Store array of linked table ID's

export const LinkedRecordID = [
  'recaTZFa2bY6Pwt7q',
  'recItptDJcmOLeAWl',
  'recLflVwRRDLwoMML',
  'recgben209azHYNBk'
];

function buildURLstring(recordArr) {
  return recordArr
    .map(record => {
      return `RECORD_ID()='${record}',`;
    })
    .join('')
    .slice(0, -1);
}

export function getLinkedTable(table, recordArr) {
  const filterForumularstr = buildURLstring(recordArr);
  return axios.get(`${settings.API_URL}${table}?filterByFormula=OR(${filterForumularstr})`);
}

///[table]?filterByFormula=OR(RECORD_ID()='recaTZFa2bY6Pwt7q',RECORD_ID()='recItptDJcmOLeAWl')

//encodeURIComponent('filterByFormula=OR(RECORD_ID()='${recordID},RECORD_ID()='${recordID}')

//https://api.airtable.com/v0/appQFHDKCFaTXB3JN/universities?api_key=keyB6q3okYlHCMMKy&filterByFormula=OR(RECORD_ID()%3D%27reccynIqp4vPBlVKW%27%2CRECORD_ID()%3D%27reccynIqp4vPBlVKW%27)



// WEBPACK FOOTER //
// ./src/components/helper.js